import React, { useContext } from 'react';
import { TitleBanner } from '@youngcapital/component-library';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withTranslation from '../helpers/withTranslation';
import { AppContext } from '../../AppContext';

const Header = ({ t, errorMessage = '', onClose }) => {
  const { blokkendoos, siteAbbr } = useContext(AppContext);

  return (
    <TitleBanner
      title={t('banner.header', { context: `site_${siteAbbr}` })}
      backgroundImages={[blokkendoos.getBannerImage()]}
      alertMessage={errorMessage}
      alertType='error'
      onClose={onClose}
      className={classnames(blokkendoos.isMobileApp() && 'mt-0')}
      alertProps={{
        iconProps: {
          title: 'close-title-banner-button'
        }
      }}
    />
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

export default withTranslation()(Header);
